export const products = {
  title: 'Termékek és szolgáltatások',
  organizations: "Összes szervezet",
  new: "Új termék",
  filter: {
    allTypes: "Összes típus",
    products: "Termékek",
    services: "Szolgáltatások"
  },
  fields: {
    product: "Termék",
    organizations: "Szervezetek",
    price: "Ár",
    actions: "Műveletek",
    tax: "% ÁFA"
  },
  tooltips: {
    duplicate: "Másolat készítése",
    edit: "Szerkesztés",
    delete: "Törlés",
  },
  messages: {
    deleteConfirm: 'Biztosan törli ezt a terméket?',
    noMoreOrgs: 'Nincs több hozzáadható szervezet',
    confirmTitle: 'Termék törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt a terméket?',
    deleteWarning: 'Ez a művelet nem visszavonható.'
  },
  copy: "Másolás",
  edit: "Szerkesztés",
  delete: "Törlés",
  moreActions: "További műveletek",
  deactivate: "Deaktiválás",
  form: {
    add: "Új termék létrehozása",
    edit: "Termék szerkesztése",
    type: {
      title: "Termék típusa",
      product: "Termék",
      service: "Szolgáltatás"
    },
    basicInfo: {
      title: "Termék adatai",
      name: "Név",
      code: "Kód",
      description: "Leírás",
      unit: "Egység",
    },
    pricing: {
      title: "Szervezet és árazás",
      price: "Ár",
      currency: "Pénznem",
      taxRate: "ÁFA kulcs (%)",
    },
    buttons: {
      add: "Termék hozzáadása",
      update: "Termék módosítása",
      cancel: "Mégse",
    }
  }
}